module.exports = __webpack_public_path__ + "img/icon_class1.d85e31b1.png";